import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-view-image',
  templateUrl: './view-image.component.html',
  styleUrl: './view-image.component.scss'
})
export class ViewImageComponent implements OnInit {

  @Input() doc: any;
  @Input() fileName: string = 'document';

  constructor(private activeModel: NgbActiveModal) { }

  onClose() {
    const vm = this;
    vm.activeModel.close();
  }

  onDownload() {
    const vm = this;
    if (!vm.doc) return;
    const extension = vm.getFileExtension(vm.doc);
    const link = document.createElement('a');
    link.href = vm.doc;
    link.download = vm.fileName + extension;
    link.click();
  }

  getFileExtension(dataUrl: string): string {
    if (dataUrl.includes('image/png')) return '.png';
    if (dataUrl.includes('application/pdf')) return '.pdf';
    return '.jpg';
  }

  ngOnInit() {
    const vm = this;
    vm.doc = 'data:image/jpeg;base64,' + vm.doc;
  }

}
